// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Bd53w{display:flex}.u42vl{margin-bottom:8px}.nD8fe{height:32px;width:32px;padding:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inlineMenu": `Bd53w`,
	"advancedTitle": `u42vl`,
	"ellipsisMenu": `nD8fe`
};
export default ___CSS_LOADER_EXPORT___;
